
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import { ClickEvent } from '@xt/client/types/home.d'

@Component({
  components: {}
})
export default class extends Vue {
  @Prop() dataSource: { event?: ClickEvent }

  handleClick() {
    this.$router.push({
      path: '/stationery/about'
    })
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
